// this is an autogenerated file from App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/ActionsColumn/Actions/Rename/Content/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_ConnectApps_App_Content_Connections_Content_ActionsColumn_Actions_Rename_Content($id: uuid!, $display_name: String!) {
  update_apps_connections_by_pk(
    pk_columns: { id: $id }
    _set: { display_name: $display_name }
  ) {
    id
    display_name
  }
}

`